export default "__VITE_ASSET__AHvF4nQ___"